import {
  BANK_TRANSFER_SUCCESS,
  BANK_TRANSFER_FAILED,
  BANK_TRANSFER_INVALID_REQUEST,
  BANK_TRANSFER_ACCOUNT_NOT_EXIST,
  BANK_TRANSFER_INVALID_CURRENCY,
  BANK_TRANSFER_INVALID_AMOUNT,
  BANK_TRANSFER_INVALID_WALLET_OWNDER_ID,
  BANK_TRANSFER_INVALID_CUSTOMER_ID,
  NETWORK_ERROR_BANK_TRANSFER,
  LOADING_BANK_TRANSFER,
  RESET_BANK_TRANSFER
} from "../types";

const initialState = {
  isLoading: false,
  invalidRequest: false,
  accountNotExist: false,
  invalidCurrency: false,
  invalidAmount: false,
  invalidWalletOwnerId: false,
  invalidCustomerId: false,
  failed: false,
  success: false,
  data: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {

    case LOADING_BANK_TRANSFER:
      return {
        ...state,
        isLoading: true,
        invalidRequest: false,
        accountNotExist: false,
        invalidCurrency: false,
        invalidAmount: false,
        invalidWalletOwnerId: false,
        invalidCustomerId: false,
        failed: false,
        success: false,
        data: "",
        networkError: "",
      };

    case BANK_TRANSFER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        invalidRequest: false,
        accountNotExist: false,
        invalidCurrency: false,
        invalidAmount: false,
        invalidWalletOwnerId: false,
        invalidCustomerId: false,
        failed: false,
        success: true,
        data: action.payload,
        networkError: "",
      };

    case BANK_TRANSFER_FAILED:
      return {
        ...state,
        isLoading: false,
        invalidRequest: false,
        accountNotExist: false,
        invalidCurrency: false,
        invalidAmount: false,
        invalidWalletOwnerId: false,
        invalidCustomerId: false,
        failed: true,
        success: false,
        data: action.payload,
        networkError: "",
      };

    case BANK_TRANSFER_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        invalidRequest: true,
        accountNotExist: false,
        invalidCurrency: false,
        invalidAmount: false,
        invalidWalletOwnerId: false,
        invalidCustomerId: false,
        failed: false,
        success: false,
        data: action.payload,
        networkError: "",
      };

    case BANK_TRANSFER_ACCOUNT_NOT_EXIST:
      return {
        ...state,
        isLoading: false,
        invalidRequest: false,
        accountNotExist: true,
        invalidCurrency: false,
        invalidAmount: false,
        invalidWalletOwnerId: false,
        invalidCustomerId: false,
        failed: false,
        success: false,
        data: action.payload,
        networkError: "",
      };

    case BANK_TRANSFER_INVALID_CURRENCY:
      return {
        ...state,
        isLoading: false,
        invalidRequest: false,
        accountNotExist: false,
        invalidCurrency: true,
        invalidAmount: false,
        invalidWalletOwnerId: false,
        invalidCustomerId: false,
        failed: false,
        success: false,
        data: action.payload,
        networkError: "",
      };

    case BANK_TRANSFER_INVALID_AMOUNT:
      return {
        ...state,
        isLoading: false,
        invalidRequest: false,
        accountNotExist: false,
        invalidCurrency: false,
        invalidAmount: true,
        invalidWalletOwnerId: false,
        invalidCustomerId: false,
        failed: false,
        success: false,
        data: action.payload,
        networkError: "",
      };

    case BANK_TRANSFER_INVALID_WALLET_OWNDER_ID:
      return {
        ...state,
        isLoading: false,
        invalidRequest: false,
        accountNotExist: false,
        invalidCurrency: false,
        invalidAmount: false,
        invalidWalletOwnerId: true,
        invalidCustomerId: false,
        failed: false,
        success: false,
        data: action.payload,
        networkError: "",
      };

    case BANK_TRANSFER_INVALID_CUSTOMER_ID:
      return {
        ...state,
        isLoading: false,
        invalidRequest: false,
        accountNotExist: false,
        invalidCurrency: false,
        invalidAmount: false,
        invalidWalletOwnerId: false,
        invalidCustomerId: true,
        failed: false,
        success: false,
        data: action.payload,
        networkError: "",
      };

    case NETWORK_ERROR_BANK_TRANSFER:
      return {
        ...state,
        isLoading: false,
        invalidRequest: false,
        accountNotExist: false,
        invalidCurrency: false,
        invalidAmount: false,
        invalidWalletOwnerId: false,
        invalidCustomerId: false,
        failed: false,
        success: false,
        data: "",
        networkError: "OOPS! Something went wrong."
      };

    case RESET_BANK_TRANSFER:
      return (state = initialState);

    default:
      return state;
  }
};
